import { render, staticRenderFns } from "./Riichicitystore.vue?vue&type=template&id=2bc49eb9&scoped=true&"
import script from "./Riichicitystore.vue?vue&type=script&lang=js&"
export * from "./Riichicitystore.vue?vue&type=script&lang=js&"
import style0 from "./Riichicitystore.vue?vue&type=style&index=0&id=2bc49eb9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc49eb9",
  null
  
)

export default component.exports